import React, { useMemo } from 'react';
import { useCountImagesWithCroppedFaces } from 'hooks';
import WarningText from 'components/common/WarningText';

const WarningImagesWithCroppedFaces = ({ className }) => {
  const countImagesWithCroppedFaces = useCountImagesWithCroppedFaces();

  const text = useMemo(
    () =>
      countImagesWithCroppedFaces === 1
        ? 'We found 1 image with a cropped face'
        : `We found ${countImagesWithCroppedFaces} images with cropped faces`,
    [countImagesWithCroppedFaces],
  );

  if (!countImagesWithCroppedFaces) return null;
  return <WarningText text={text} className={className} />;
};

export default WarningImagesWithCroppedFaces;
